/* eslint-disable react/display-name */
// import { useEffect, useState } from 'react';
// import { isMobile } from 'react-device-detect';

import { Box, Button, Container, Flex, Heading, Text } from '@brand/components';

import { Image, Link } from '@hoa/atoms';
// import { ButtonLink } from '@hoa/molecules';

import { useTrade } from '@hoa/hooks';
import { prismicImgixLoader } from '@hoa/utils';

interface Props {
  backgroundImage?: string;
  title?: string;
  subtitle?: string;
  ctaButtonText: string;
}

const CategoryHero = ({
  backgroundImage,
  title,
  subtitle,
  ctaButtonText,
}: Props): JSX.Element => {
  // const { t } = useTranslation();
  // const [phoneNumber, setPhoneNumber] = useState<string>(``);
  const { tradeQuoteUrl } = useTrade();

  // useEffect(() => {
  //   const phoneNumber = `tel:${t(`category:hero.urgency.number`)}`;
  //   setPhoneNumber(phoneNumber);
  // }, []);

  // phone number not working for now
  // const urgentRepair =
  //   trade === `electricians` ||
  //   trade === `heating-and-air-conditioning-contractors`;

  return (
    <Box as="section" position="relative">
      <Box
        position="absolute"
        width="100vw"
        h="100%"
        zIndex={-2}
        overflow="hidden"
      >
        <Image
          src={backgroundImage ? backgroundImage : ''}
          alt="Jaimy category hero image"
          layout="fill"
          objectFit="cover"
          objectPosition="40% 40%"
          quality={80}
          loader={prismicImgixLoader}
          priority
        />
      </Box>
      <Box
        position="absolute"
        zIndex={-1}
        width="100%"
        height="100%"
        bg="rgba(255, 255, 255, .55)"
      />
      <Container>
        <Flex align="center" py={40} direction={[`column`, null, `row`]}>
          <Box>
            <Heading as="h1" variant="h2" mb={4} maxW="80%">
              {title}
            </Heading>
            <Text
              as="h2"
              size="lg"
              fontWeight={600}
              mb={10}
              maxW={['90%', null, '80%']}
            >
              {subtitle}
            </Text>
            <Box textAlign={['start', null, 'start']}>
              <Link
                href={tradeQuoteUrl}
                anchorProps={{
                  _hover: {
                    textDecoration: `none`,
                  },
                }}
              >
                <Button my={4} variant={'solid'}>
                  {ctaButtonText}
                </Button>
              </Link>
            </Box>
            {/* {urgentRepair && (
              <Flex alignItems="center" mt={12}>
                <Text mr={4} color="primary.base">
                  <Trans i18nKey="category:hero.urgency.title" />
                </Text>
                <Box>
                  <ButtonLink
                    href={isMobile ? phoneNumber : ``}
                    variant="outlineRed"
                    size="sm"
                    onClick={e => {
                      !isMobile && e.cancelable && e.preventDefault();
                    }}
                  >
                    {t(`category:hero.urgency.number`)}
                  </ButtonLink>
                </Box>
              </Flex>
            )} */}
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default CategoryHero;
